/*
 * @Author: crazycattle
 * @Date: 2022-01-08 18:00:34
 * @Description: content
 */
module.exports = {
    lang: {
        userLogin:'帳號密碼登錄',
        telLogin:'簡訊驗證碼登錄',
        plaUser:'請輸入帳號',
        plaPassword:'請輸入密碼',
        rememberPassword:'記住密碼',
        forgetPassword:'忘記密碼？',
        login:'登錄',
        reg:'沒有帳號？立即註冊',
        inputCode:'請輸入驗證碼',
        getCode:'獲取驗證碼',
        passwordMsg:'兩次輸入的密碼不一樣',
        passwordLang:'密碼長度6-20位，限英文及數字',
        register:'註冊',
        wirteData:'完善資料',
        complete:'完成',
        inputTel:'請輸入手機號碼',
        confirmPassword:'請再次確認密碼',
        save:'保存',
        inputCnName:'請輸入中文名字',
        inputEnName:'請輸入英文名字',
        selectSex:'請選擇性別',
        schoolType:'請選擇學校類型',
        man:'男',
        women:'女',
        trainSchool:'培訓學校',
        kindergarten:'幼儿園',
        selectArea:'請選擇省份',
        selectCity:'請選擇城市',
        selectSchool:'請選擇學校',
        selectBirthday:'請輸入生日',
        wirteName:'請填寫中英文名稱',
        regComplete:'恭喜您，註冊成功',
        startStudy:'開始學習',
        thumbs:'按讚',
        collection:'收藏',
        out:'退出',
        meSc:'我的收藏',
        record:'瀏覽記錄',
        playAll:'播放全部',
        audioName:'音訊名稱',
        videoName:'視頻名稱',
        myBook:'我的書架',
        personalCenter:'個人中心',
        notData:"暫無數據",
        addBaby:'添加寶寶',
        headerImg:'頭像',
        changeHeaderImg:'更換頭像',
        cnName:'中文名',
        enName:'英文名',
        sex:'性别',
        birthday:'生日',
        gong:'共',
        shou:'首',
        selectSchoolType:'學校類型',
        schoolArea:'學校所在省份',
        schoolCity:'學校所在市區',
        advanceSelectionArea:'請先選擇省份',
        advanceSelectionCity:'請先選擇城市',
        schollName:'學校名稱',
        delete:'刪除',
        notHistory:'暫無歷史記錄',
        clearHistory:'清除全部記錄',
        history:'最近瀏覽',
        langChange:'繁簡切換',
        babyChange:'寶寶切換',
        changePassword:'修改密碼',
        notScData:'暫無收藏記錄',
        editPersonal:'編輯個人資料',
        tel:'手機號碼',
        list:'清單',
        orderPlay:'順序播放',
        randomPlay:'隨機播放',
        singlePlay:'單曲迴圈',
        cthumbs:'取消點讚',
        ccollection:'取消收藏',
        noBaby:'無法對當前寶寶進行解綁哦~',
        changetext:'已為您自動切換字體，請重新點擊登入按鈕',
        telerr:'手機格式錯誤',
        jiebang:'申請解綁',
        jiechu:'解除後學生將失去使用的許可權，請確認後在解除綁定哦',
        queren:'確認',
        selectHeaderImg:'選擇頭像',
        backHome:'返回至首頁',
        deletejilu:'此操作將刪除該記錄, 是否繼續?',
        ys:'我已閱讀並同意《吉的堡百樂匯隱私政策》',
        yuedu:'請閱讀並同意《吉的堡百樂匯隱私政策》',
        jiaoshi:'教師帳號',
        loadingStatu:'拼命加載中',
        yanz:'驗證密碼',
        qiehuan:'切換成功',
        totalTxt1: '共',
        totalTxt2: '首'
    }
}



//////////////////
// WEBPACK FOOTER
// ./static/lang/zh-TW.js
// module id = 9m9z
// module chunks = 21